import { render } from "./whatsapp-button.vue?vue&type=template&id=1cf1698e&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./whatsapp-button.vue?vue&type=script&lang=js"
export * from "./whatsapp-button.vue?vue&type=script&lang=js"

import "./whatsapp-button.vue?vue&type=style&index=0&id=1cf1698e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__